import React, { useState } from "react";
import "./SendToDashboardModal.css";

const SendToDashboardModal = ({
  isOpen,
  onClose,
  onSubmit,
  boards,
  isSendDisabled,
}) => {
  const [selectedBoard, setSelectedBoard] = useState("");

  if (!isOpen) return null;

  return (
    <div className="send-modal-overlay">
      <div className="send-modal">
        <div className="title-modal-chart">
          <p>Enviar gráfico a tablero</p>
        </div>
        <div className="body-modal-chart">
          <select
            value={selectedBoard}
            onChange={(e) => setSelectedBoard(e.target.value)}
          >
            <option value="">Seleccionar tablero</option>
            {boards.map((b) => (
              <option key={b.name} value={b.name}>
                {b.displayName}
              </option>
            ))}
          </select>
          <div className="send-modal-actions">
            <button onClick={onClose} className="cancel-chart">Cancelar</button>
            <button
            className="send-chart"
              disabled={isSendDisabled}
              onClick={() => {
                if (selectedBoard) {
                  const selectedBoardObj = boards.find(
                    (b) => b.name === selectedBoard
                  );
                  onSubmit(
                    selectedBoard,
                    selectedBoardObj?.displayName || selectedBoard
                  );
                  setSelectedBoard("");
                }
              }}
            >
              Enviar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SendToDashboardModal;
